/* eslint-disable no-restricted-syntax */
import { toast } from 'react-toastify';
import { iTHREE } from '@treedis/tour-loader';
import { SweepPath } from '@/_models/Sweep';

export const moveToSweeps = async ({
  sweepsPath,
  targetRotation,
  poseRotation,
  rotationAngle,
  rotationSpeed,
  transitionSpeed,
  stopAfterSweep,
  showcaseSweep,
}: {
  sweepsPath: SweepPath[];
  targetRotation: any;
  poseRotation: any;
  rotationAngle: any;
  rotationSpeed: any;
  transitionSpeed: any;
  stopAfterSweep: any;
  showcaseSweep: any;
}) => {
  let iteration = 0;
  let currentRotation = poseRotation;
  const maxSpeed = 5000;
  const minSpeed = 500;
  const delay = 5000;
  const THREE = await iTHREE();

  if (showcaseSweep) {
    for await (const { id, rotation, next } of sweepsPath) {
      let currentSpeed = transitionSpeed;

      if (next) {
        const curQuaternion = new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w);
        const nextQuaternion = new THREE.Quaternion(
          next.rotation.x,
          next.rotation.y,
          next.rotation.z,
          next.rotation.w,
        );
        const angle = (curQuaternion.angleTo(nextQuaternion) * 180) / Math.PI;

        if (angle > rotationAngle) {
          currentRotation.y += angle;
          currentSpeed = rotationSpeed;
        }
      } else {
        currentRotation = targetRotation;
      }

      await showcaseSweep.moveTo(id, {
        rotation: currentRotation,
        transition: showcaseSweep.Transition.FLY,
        transitionTime: maxSpeed + minSpeed - (maxSpeed * currentSpeed) / 100,
      });

      if (iteration > 0 && iteration !== sweepsPath.length - 1 && !(iteration % stopAfterSweep)) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
      iteration += 1;
    }
    return Promise.resolve();
  }
  toast.error('Wait for the model to load');
  return Promise.reject();
};
